import React, { Component } from 'react';
import * as firebase from 'firebase';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import {List, ListItem} from 'material-ui/List';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Checkbox from 'material-ui/Checkbox';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import ActionSearch from 'material-ui/svg-icons/action/search';
import LinearProgress from 'material-ui/LinearProgress';
import styled from 'styled-components';
import LoadingState from '../Loading';

import { sendNotifications } from '../../utils/notificationService';
import { searchUser } from '../../actions/userActions';

import {
  FormTitle,
  Pre,
  Code
} from '../Styles/index';

const Container = styled.div`
  max-width: 1336px;
  min-width: 1120px;
  margin: 0 auto;
  padding: 32px 16px;
 
`

const Row = styled.div`
  display: flex
`
const Col = styled.div`
  flex: ${props => props.flex || 0};
  padding: 0 8px;
  ${props => props.borderRight && `border-right: ${props.borderRight}px solid gray`};
`
const H3 = styled.h3`
  padding: 4px 16px;
  font-weight: 600;
  text-transform: uppercase;
`

const ListContainer = styled.div`
  max-height: 60vh;
  overflow: auto;
`

class NotificationIndex extends Component {

  state = {
    clients: [],
    selectedClients: [],
    selectAll: false,
    loading: false,
    message: '',
    urgent: false,
    products: {},
    productKey: 'not-a-key',
    selectedProduct: '',
    searchQuery: '',
    isSearching: false,
    logs: {}
  }



   _handleSelectChange = (event, index, value) => {
    console.log(this.state.products[value])
    this.setState({
      productKey: value,
      selectedProduct: this.state.products[value] !== undefined ? {...this.state.products[value], key: value } : '', 
    });
  }

  _handleChange = event => {
      return this.setState({
        [event.target.name]: event.target.value
      });
  }

  _handleCheck = (event, value) => {
    this.setState({
      selectAll: value
    }, () => {
      if (this.state.selectAll) {
        this.setState({
          selectedClients: this.state.clients 
        });
      } else {
        this.setState({
          selectedClients: []
        });
      }
    });
  }

  _toggleSelected(client){ 
    const existClient = this.state.selectedClients.find(c => c.key === client.key);
    if (!existClient) {
      this.setState({
        selectedClients: [...this.state.selectedClients, client] 
      });
    } else {
      this.setState({
        selectedClients: this.state.selectedClients.filter(c => c.key !== client.key)
      });
    } 
    
  }

  _handleSearchChange = event => {
    this.setState({
      [event.target.name]: event.target.value.trim()
    });

    if (event.target.value.trim() === '') {
      this.setState({
        isSearching: false
      })
    } else {
      this.props.searchUser({ query: event.target.value.trim() });
      this.setState({
        isSearching: true
      })
    }

  }

  _handleSearchSubmit = event => {
    event.preventDefault();
    this.props.searchUser({ query: this.state.searchQuery });
    this.setState({
      isSearching: true
    })
  }

  _handleSubmit = async event => {
    event.preventDefault();
    if (this.state.selectedClients.length === 0 || this.state.message.trim() === '') {
      this.setState({
        logs: {
          message: 'Message or selected client list is empty you cannot send notification'
        }
      });
      return;
    }
    try {
      const token = localStorage.getItem('jwtToken');
      this.setState({
        loading: true,
      })
      const response = await sendNotifications({ 
        users: this.state.selectedClients, 
        message: this.state.message,
        urgent: this.state.urgent,
        product: this.state.selectedProduct,  
        token
      })
      console.log(response)
      this.setState({
        logs: response.data.logs,
        loading: false,
        message: '',
        urgent: false,
        selectedClients: [],
        selectedProduct: '',
        productKey: 'not-a-key'
      })
    } catch(e) {
      this.setState({
        loading: false,
      })
      console.log(e);
    }
  }

  componentWillMount() {

    this.setState({
      loading: true 
    });
    firebase.database().ref().child('clients').orderByChild('no').on('value', clients => {
      const clientList = [];
      clients.forEach(client => {
        clientList.push({ ...client.val(), key: client.key})
      })

      this.setState({
        clients:  clientList,
        loading: false
      });
    })
    firebase.database().ref().child('products').on('value', products => {
      if (products.val()) {
        console.log(products.val())
        this.setState({
          products: products.val() 
        });
      }
    })
  }

  _renderProducts(){
    return Object.keys(this.state.products).map(key => 
      <MenuItem key={key} value={key} primaryText={this.state.products[key].product_name}/>
    )
  }

  render() {
    return (
      <div style={{ overflow: 'auto' }}>
        {this.state.loading 
          ? <LoadingState/>
          :
          <Container>
            <Row>
              <Col flex={1}>
                <FormTitle>Push Notifications</FormTitle>
                <div style={{height: '16px'}}></div>
              </Col>
            </Row>
            <Row>
              <Col flex={1} borderRight={2}>
                <div style={{ display: 'flex', alignItems: 'center', paddingBottom: '8px'}}>
                  <H3>Clients</H3>
                  <Checkbox
                    checked={this.state.selectAll}
                    onCheck={this._handleCheck}
                    label="Sent to all clients"
                  />
                </div>
                <div>
                  <form style={{ diplay: 'flex'}} onSubmit={this._handleSearchSubmit}>
                    <TextField
                      name="searchQuery"
                      id="searchQuery"
                      onChange={this._handleSearchChange}
                      value={this.state.searchQuery}
                      hintText="Search users"
                    />
                    <FlatButton
                      style={{minWidth: '48px'}}
                      type="submit"
                      icon={<ActionSearch />}
                    />
                  </form>
                </div>
                <ListContainer>
                  { this.state.isSearching ? 
                    <List>
                      {this.props.user.users.map(client =>
                        <ListItem
                          key={client.key}
                          value={client.key}
                          primaryText={client.name}
                          secondaryText={client.email}
                          style={!!this.state.selectedClients.find(c => c.key === client.key) ? {  backgroundColor: 'rgba(0,0,0,.25)s' } : {}}
                          onClick={() => {this._toggleSelected(client)}}
                        />
                      )}
                    </List>
                    : <List>
                    {this.state.clients.map(client => 
                      <ListItem
                        key={client.key}
                        value={client.key}
                        primaryText={client.name}
                        secondaryText={client.email}
                        style={!!this.state.selectedClients.find(c => c.key === client.key) ? {  backgroundColor: 'rgba(0,0,0,.25)s' } : {}}
                        onClick={() => {this._toggleSelected(client)}}
                      />
                    )}
                  </List>}
                </ListContainer>
              </Col>
              <Col flex={1} borderRight={2}>
                <div style={{ paddingBottom: '8px' }}>
                  <H3>Selected Clients</H3>
                </div>
                <ListContainer>
                  <List>
                    {this.state.selectedClients.map(client => 
                      <ListItem
                        key={client.key}
                        value={client.key}
                        primaryText={client.name}
                        secondaryText={client.email}
                      />
                    )}
                  </List>
                </ListContainer>
              </Col>
              <Col flex={2}>
                <div style={{ paddingBottom: '8px' }}>
                  <H3>Message</H3>
                  <form style={{ padding: '16px 16px'}} onSubmit={this._handleSubmit}>
                  <SelectField
                    floatingLabelText="Select Product (Optional)"
                    value={this.state.productKey}
                    onChange={this._handleSelectChange}
                  >
                    <MenuItem value={'not-a-key'} primaryText='No Product'/>
                    { this._renderProducts() }
                  </SelectField>
                    <TextField
                      textareaStyle={{ backgroundColor: 'rgba(0,0,0,0.04)' }}
                      fullWidth
                      id="message"
                      name="message"
                      floatingLabelText="Message"
                      multiLine={true}
                      rows={8}
                      value={this.state.message}
                      onChange={this._handleChange}
                    />
                    <Checkbox
                      checked={this.state.urgent}
                      onCheck={(e, val) => this.setState({ urgent: val })}
                      label="Urgent?"
                    />
                    <div style={{height: '16px'}}></div>
                    <RaisedButton type='submit' label="Broadcast" primary={true} />
                  </form>
                </div>
              </Col>
            </Row>
            <div style={{height: '32px'}}></div>
            <Row>
              <H3>Report</H3>
            </Row>
            <Row>
              <div style={{ width: '100%', padding: '0 16px', opacity: this.state.loading ? 1 : 0 }}>
                <div style={{height: '16px'}}></div>
                <LinearProgress style={{background: '#dfdfdf'}} mode="indeterminate"/>
                <div style={{height: '16px'}}></div>
              </div>
            </Row>
            <Row>
              <div style={{ width: '100%', padding: '0 16px'}}>
                <Pre>
                  <Code>
                    {`${JSON.stringify( this.state.logs || 'No Log', undefined, 2)}`}
                  </Code>
                </Pre>
              </div>
            </Row>
          </Container>
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({ user: state.user.searched });
const mapDispatchToProps = { searchUser };
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NotificationIndex));



// WEBPACK FOOTER //
// ./src/components/Notification/NotificationIndex.js